import debounce from "lodash/debounce";
import animateSwitcher from "../../scripts/animateSwitcher";

const animateSwitcherDebounced = debounce(animateSwitcher, 100);

export default {
    install(Vue) {
        Vue.mixin({
            mounted() {
                animateSwitcherDebounced();
            },
        });
    }
}